import React, { useState } from 'react';
import '../assets/style.css';
import FullScreenImage from "./FullScreenImage";

import infoPowerpoint from '../assets/images/IMPACT REPORT/presentation.jpg';
import infoGraphicHandout from '../assets/images/IMPACT REPORT/handout.jpg';

const Magazine = () => {
  const [currentIndex, setCurrentIndex] = useState(null);

  const images = [infoGraphicHandout, infoPowerpoint];

  const handleImageClick = (index) => setCurrentIndex(index);
  const handleCloseFullScreen = () => setCurrentIndex(null);
  const handlePrevImage = () =>
    currentIndex !== null && setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  const handleNextImage = () =>
    currentIndex !== null && setCurrentIndex((prev) => (prev + 1) % images.length);

  return (
    <div className="p-3 md:p-10 m-5 md:m-10 columns-1">
      <main className="container mx-auto">
        <div className="mx-4 sm:mx-8 md:mx-16 lg:mx-52 xl:mx-64 2xl:mx-80 -mt-6 pt-6">

          {/* Title */}
          <h1
            className="text-center leading-tight md:leading-normal mb-0 -mt-7"
            style={{ fontFamily: 'Bebas Neue', color: '#6ac9cb', fontSize: '3rem' }}
          >
            CIA Community Impact Report
          </h1>

          {/* Description */}
          <p className="text-left text-gray-600 mb-5 md:mb-10 2xl:mb-14 leading-relaxed">
            I led the design and development of an 8-page Community Impact Report showcasing CIA's initiatives and measurable outcomes. My responsibilities included designing data visualizations, ensuring brand consistency, and collaborating with leadership on an accurate and engaging report.
          </p>

          {/* Issuu Embed */}
          <div className="w-full max-w-full mx-auto overflow-hidden shadow-md px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 mb-10">
            <iframe
              title="issuu-embed"
              src="https://e.issuu.com/embed.html?d=24-25_ia_community_impact_report_issue&u=ciacollege"
              className="w-full h-[360px] sm:h-[400px] md:h-[450px] lg:h-[500px] xl:h-[550px] 2xl:h-[600px]"
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>

          {/* Section Title */}
          <h2 className="text-2xl sm:text-3xl md:text-2xl font-bold text-gray-800 mb-4 mt-8 text-left">
            Infographics for Handouts & Presentations
          </h2>

          {/* Images Grid */}
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 place-items-center mt-4 mb-6">
            {images.map((img, index) => (
              <div
                key={index}
                className="w-full sm:w-[500px] md:w-full cursor-pointer"
                onClick={() => handleImageClick(index)}
              >
                <img
                  src={img}
                  alt={`Infographic ${index + 1}`}
                  className="w-full h-[500px] object-cover rounded shadow-md hover:scale-105 transition-transform duration-300"
                />
              </div>
            ))}
          </div>

          {/* Full-Screen Image */}
          {currentIndex !== null && (
            <FullScreenImage
              src={images[currentIndex]}
              onClose={handleCloseFullScreen}
              onPrev={handlePrevImage}
              onNext={handleNextImage}
            />
          )}

        </div>
      </main>
    </div>
  );
};

export default Magazine;
